import { Component, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NavMapComponent } from '../../../shared/components/nav-map/nav-map.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ManagementAccountControllerService, ManagementAccountResponse } from 'api-auth';
import { take } from 'rxjs/internal/operators/take';
import { MatDialog } from '@angular/material/dialog';
import { ManageUserComponent } from './manage-user/manage-user.component';
import { MatSelectModule } from '@angular/material/select';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
interface UsersData {
	all: ManagementAccountResponse[];
	active: ManagementAccountResponse[];
	inactive: ManagementAccountResponse[];
}
@Component({
	selector: 'app-users',
	standalone: true,
	imports: [
		ReactiveFormsModule,
		MatIconModule,
		MatCardModule,
		MatButtonModule,
		MatDividerModule,
		MatTooltipModule,
		MatSelectModule,
		NavMapComponent,
		TranslateModule,
		MatTableModule,
		MatPaginatorModule,
	],
	templateUrl: './users.component.html',
	styleUrl: './users.component.scss',
})
export class UsersComponent {
	@ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
	pageOptions = [50, 100, 200];
	users: UsersData = {
		all: [],
		active: [],
		inactive: [],
	};

	displayedColumns: string[] = ['NAME', 'IDENTIFIER', 'ROLE', 'EMAIL', 'SCOPES', 'ACTIVE'];
	dataSource!: MatTableDataSource<any>;

	filterUserStatus: FormControl = new FormControl('ACTIVE');

	private lockAction = false;

	constructor(private apiManagementAccount: ManagementAccountControllerService, private dialog: MatDialog) {
		this.getAccounts();
	}

	itemAction(action: 'NEW' | 'EDIT' | 'DEACTIVATE' | 'ACTIVATE' | 'DELETE', item?: any) {
		if (this.lockAction) {
			return;
		}
		this.lockAction = true;
		const dialogRef = this.dialog.open(ManageUserComponent, {
			width: '600px',
			data: {
				mode: action,
				type: 'USER',
				item,
			},
		});

		dialogRef
			.afterClosed()
			.pipe(take(1))
			.subscribe(result => {
				if (result) {
					this.getAccounts();
				}
				this.lockAction = false;
			});
	}

	filterUsers() {
		if (this.paginator.toArray()[0]) {
			this.paginator.toArray()[0].pageIndex = 0;
			this.paginator.toArray()[0].pageSize = this.pageOptions[0];
		}
		this.getAccounts();
	}

	getAccounts() {
		const pagination = {
			index: this.paginator.toArray()[0] && this.paginator.toArray()[0].pageIndex ? this.paginator.toArray()[0].pageIndex : 0,
			pageSize: this.paginator.toArray()[0] && this.paginator.toArray()[0].pageSize ? this.paginator.toArray()[0].pageSize : this.pageOptions[0],
		};

		this.apiManagementAccount
			.getMgmtAccounts(pagination.index, pagination.pageSize)
			.pipe(take(1))
			.subscribe({
				next: response => {
					this.users = {
						all: response.content || [],
						active: response.content?.filter(user => user.active) || [],
						inactive: response.content?.filter(user => !user.active) || [],
					};

          // TO DO paginated api should have param for status then this block will be replaced with
          // this.dataSource = new MatTableDataSource<any>(response.content);
					let filteredUsers = this.users.all;
					if (this.filterUserStatus.value === 'ACTIVE') {
						filteredUsers = this.users.active;
					} else if (this.filterUserStatus.value === 'INACTIVE') {
						filteredUsers = this.users.inactive;
					}


					this.dataSource = new MatTableDataSource<any>(filteredUsers);
					if (this.paginator.toArray()[0]) {
						this.paginator.toArray()[0].length = response.totalElements || 0;
					}
				},
			});
	}
}
